import React, { useState, useContext } from "react";

import ReactDOM from "react-dom";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import useValidationInput from "../../Hooks/useValidationInput.js";
import RadioIcon from "../Commands/RadioIcon/RadioIcon";
import ValidationCommand from "../Commands/ValidationCommand/ValidationCommand";
import useChangeMode from "../../Hooks/useChangeMode.js";
import { store } from "../../store.js";
import Tree from "../Tree/Tree";

export default function TreeViewDialog (props)  {
  
  //const globalState = useContext(store);
  //const currentFormat = globalState.state.formData;
  const currentFormat = props.data;
 
  const getTypeData = () => {
    var treeData = []
    currentFormat.tree.forEach(item => {
      if (item.type == props.typeData)
        treeData.push({...item, childs:[]})
    });

    if (props.previousForms)
    props.previousForms.forEach(item => {
      if (item.type == props.typeData)
        treeData.push({...item, childs:[]})
    });

    currentFormat.apiSchemas && currentFormat.apiSchemas.forEach(item => {
      if (item.type == props.typeData)
        treeData.push({...item, childs:[]})
    });

    
  }

  const getAncestorTree = (treeData, ancestorTree  ) => {
    if (ancestorTree.value.length != 0) return
    treeData.forEach(item => {
      
      if (item.id == props.ancestorId) 
        ancestorTree.value.push(item) 
      
      getAncestorTree(item.childs, ancestorTree)
    })
  }

  
  const getTreeData = () => {
    var treeData = props.customData ? props.customData :
     (props.typeData ?  getTypeData(): [...currentFormat.tree, ...(props.previousForms? props.previousForms : []),...(currentFormat.apiSchemas ? currentFormat.apiSchemas : [])])
    
    
    if (props.ancestorId != undefined) {
      var ancestorTree = {value : []}
      
      getAncestorTree(treeData, ancestorTree)
      return ancestorTree.value
    }
    else {
      return treeData
    }
     
  }
  const data = getTreeData(); //currentFormat.tree ;
   
  const [position, setPosition] = useState({ 
    operation : currentFormat && currentFormat.menu.operation.Select,
    type: props.type,
    isOpen:true,
    value:""
  });
  
  const getTitle = () => {
    if (props.title)
      return props.title

    const replaces = currentFormat.menu[position.type].replacesValues
    const currentType =  position.errorType ? position.errorType : position.operation
    return currentFormat.log.filter(
      log => log.type == currentType
    ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces)}</span>})[0]
  }
  
  const onClickClose = (e) => {
    if(e) e.preventDefault(); 
    
    props.onClose();
    var updatedPosition = JSON.parse(JSON.stringify(position));
    updatedPosition.isOpen = false;
    setPosition(updatedPosition);
  }

  const replaceValue = (value, replaces) => {
    if( replaces )
      replaces.map(replace => value = value.replace(replace.old, replace.new)) 
    return value
  }

  const onSelectItem = (checkeds, dataLabels, detail, newCheckedsPath) => {  
    
    var updatedPosition = JSON.parse(JSON.stringify(position));
      
      //updatedPosition["checkeds"] = [...(updatedPosition.checkeds ? updatedPosition.checkeds : []), ...checkeds];
      updatedPosition["checkeds"] = checkeds;
      updatedPosition["dataLabels"] = dataLabels;
      updatedPosition["detail"] = detail;
      updatedPosition["checkedsPath"] = newCheckedsPath;

    setPosition(updatedPosition);
  }


  const onUnSelectItem = (checkeds, dataLabels, detail) => {  
    var updatedPosition = JSON.parse(JSON.stringify(position));
    //if (checkeds.length == 0) {
      updatedPosition["checkeds"] = undefined;
      updatedPosition["dataLabels"] = undefined;
      updatedPosition["detail"] = undefined;
   /* } else {
      updatedPosition["checkeds"] = checkeds;
      updatedPosition["dataLabels"] = dataLabels;
      updatedPosition["detail"] = detail;
    }*/

    setPosition(updatedPosition);
  }

  const onSaveSelection = (e, position) => {
    
  
    e.preventDefault();
    if (position.checkeds) props.onSaveSelection(e, position)
  }
  
  return (
    position.isOpen && ReactDOM.createPortal(
    <div className="dialogForm" style ={{   height: "auto", width: "auto", padding: "20px" }}>
      <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
        <div style ={{ marginTop: "6px", marginRight: "10px" }}>
          { getTitle() }
        </div>
        
        <div onClick={(e) => onClickClose(e) } style ={{ marginLeft: "auto" }}>
          <CloseCommand />
        </div>
      </div>
      <div style ={{  display: "flex" }} onClick={(e) => {e.stopPropagation() }}>
        <div style ={{  marginTop: "4px", marginRight: "5px"}}>
          <Tree 
            onCheckedItem = {(checkeds, dataLabel, menuPaths, newCheckedsPath) =>  onSelectItem(checkeds, dataLabel, menuPaths, newCheckedsPath)}
            onUnCheckedItem = {(checkeds, dataLabel, menuPaths) =>  onUnSelectItem(checkeds, dataLabel, menuPaths)}
            leafSelection = {props.leafSelection} 
            singleChecked = {props.singleChecked != undefined ? props.singleChecked : true} 
            
            withCheckBox = {props.withCheckBox} 
            menuItems = {data}/>
        </div>
        
      </div>
      <div className="modal-line-right">
        <div onClick={(e) => onClickClose(e)} >
          <input style ={{ border: "1px solid lightGray", backgroundColor: "white", color:"lightGray", fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} type="button" 
          className="button" value="Cancel"/>
        </div>
        <div onClick ={(e) => !position.errorType && onSaveSelection(e, position)}>
          <input style ={{ backgroundColor: position.errorType ? "lightGray" : "#008dff", fontSize:"12px", height: "20px", padding: "0px", width: "70px", }} type="button" className="button" value="Save"/>
        </div>
      </div>
      
    </div>,
     props.parentId ? document.getElementById(props.parentId) : document.body
    ) 
  );
}

